export default {
  map: 'read:map',
  debugMap: 'create:entity',
  installDevices: 'create:entity',
  installDevicesMobile: 'create:entity',
  information: 'read:information',
  reports: 'read:reports',
  businesses: 'read:business-management',
  entities: 'index:entity',
  users: 'read:user',
  // devices: 'create:device',
  // subscriptionManagement: 'read:subscriptions',
  // subscriptions: 'read:subscriptions',
  // maintenancePlans: 'index:maintenance-plan',
  notifications: 'create:notification',
  missingEntities: 'manage:missing-entities',
  webshop: 'create:order'
}
